import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "body-1 mt-1"
}
const _hoisted_2 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_3 = { class: "timer-trigger-row mt-2 mb-2" }
const _hoisted_4 = { class: "timer-label" }
const _hoisted_5 = { class: "timer-label" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex justify-space-between align-items-center mt-2 mb-1"
}
const _hoisted_7 = {
  key: 1,
  class: "day-selector mt-1"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_10 = { class: "api-settings-pane" }
const _hoisted_11 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_12 = { class: "actions-col d-flex" }
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_api_request_body_settings = _resolveComponent("api-request-body-settings")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_gain_configuration_versions_modal = _resolveComponent("gain-configuration-versions-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_card, {
      "no-header": "",
      class: "width-100"
    }, {
      body: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString($setup.form.configurationName), 1),
                _createElementVNode("h3", {
                  class: "body-1 cursor-pointer mt-1",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openVersionModal && $setup.openVersionModal(...args)))
                }, _toDisplayString(_ctx.$t('currentVersion') + ': ' + $props.configuration.version), 1),
                ($setup.props.nextRunTimestamp)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.$t('nextRun') + ': ' + $setup.formatTimestamp($setup.props.nextRunTimestamp)), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 15 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  ref: "formRef",
                  model: $setup.form,
                  rules: $setup.formRules
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('outputFileNameWithoutExtension'),
                      prop: "outputFileName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          disabled: !$setup.showOutputNameMismatchWarning,
                          placement: "top",
                          content: _ctx.$t('outputFileNameNotMatchingAnyFileConfig')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.form.outputFileName,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.outputFileName) = $event)),
                              size: "small",
                              class: _normalizeClass({ 'error-input': $setup.showOutputNameMismatchWarning }),
                              onChange: $setup.emitUpdate
                            }, null, 8, ["modelValue", "class", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["disabled", "content"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('apiConnectionName'),
                      class: "mb-0",
                      prop: "apiConnectionName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          disabled: 
                  $setup.props.apiConnections.find(
                    c => Number(c.apiName) === Number($setup.form.apiConnectionName)
                  )?.enabled
                ,
                          placement: "top",
                          content: _ctx.$t('disabledApiConnectionRunsAreBlocked')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: $setup.form.apiConnectionName,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.apiConnectionName) = $event)),
                              disabled: "",
                              size: "small",
                              filterable: "",
                              onChange: $setup.emitUpdate
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.apiNameOptions, (opt) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: opt.value,
                                    label: opt.label,
                                    value: opt.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["disabled", "content"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('executionTrigger'),
                      class: "mb-0",
                      prop: "executionTrigger"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: $setup.form.executionTrigger,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.executionTrigger) = $event)),
                          disabled: "",
                          size: "small",
                          filterable: "",
                          onChange: $setup.emitUpdate
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($setup.ExecutionTrigger), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item,
                                label: item,
                                value: $setup.ExecutionTrigger[item]
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _ctx.$t('numberOfRetries'),
                              prop: "numberOfRetries"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input_number, {
                                  modelValue: $setup.form.numberOfRetries,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.numberOfRetries) = $event)),
                                  min: 0,
                                  max: 20,
                                  onChange: $setup.emitUpdate
                                }, null, 8, ["modelValue", "onChange"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _ctx.$t('retryDelayMilliseconds'),
                              prop: "retryDelay"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input_number, {
                                  modelValue: $setup.form.retryDelay,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.retryDelay) = $event)),
                                  min: 0,
                                  max: 30000,
                                  step: 100,
                                  onChange: $setup.emitUpdate
                                }, null, 8, ["modelValue", "onChange"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"]),
                ($setup.form.executionTrigger === $setup.ExecutionTrigger.Schedule)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_el_divider, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('timerTriggerConditions')), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('thisReportWillRun')), 1),
                        _createVNode(_component_el_select, {
                          modelValue: $setup.form.timerConditions.repeatFrequency,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.timerConditions.repeatFrequency) = $event)),
                          size: "small",
                          class: "frequency-select",
                          onChange: _cache[7] || (_cache[7] = 
                  newVal => {
                    $setup.handleFrequencyChange(newVal);
                  }
                )
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.repeatFrequencyOptions, (opt) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: opt.value,
                                label: _ctx.$t(opt.label),
                                value: opt.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('starting')), 1),
                        _createVNode(_component_el_date_picker, {
                          modelValue: $setup.form.timerConditions.startDate,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form.timerConditions.startDate) = $event)),
                          type: "date",
                          placeholder: _ctx.$t('startDate'),
                          size: "small",
                          class: "start-date-picker",
                          format: "YYYY-MM-DD",
                          "value-format": "YYYY-MM-DD",
                          onChange: $setup.emitUpdate
                        }, null, 8, ["modelValue", "placeholder", "onChange"])
                      ]),
                      _createVNode(_component_el_row, {
                        gutter: 20,
                        class: "mt-2 mb-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _ctx.$t('endingDate')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: $setup.form.timerConditions.endDate,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.form.timerConditions.endDate) = $event)),
                                    type: "date",
                                    placeholder: _ctx.$t('optionalEndingDate'),
                                    size: "small",
                                    format: "YYYY-MM-DD",
                                    "value-format": "YYYY-MM-DD",
                                    clearable: "",
                                    onChange: $setup.emitUpdate
                                  }, null, 8, ["modelValue", "placeholder", "onChange"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              (
                    $setup.form.timerConditions.repeatFrequency ===
                    $setup.RepeatFrequency.Daily
                  )
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    label: _ctx.$t('executionTime')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: $setup.form.timerConditions.executionTime,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form.timerConditions.executionTime) = $event)),
                                        filterable: "",
                                        size: "small",
                                        onChange: $setup.emitUpdate
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.executionTimeOptions, (time) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: time,
                                              label: time,
                                              value: time
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "onChange"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              (
                    $setup.form.timerConditions.repeatFrequency ===
                    $setup.RepeatFrequency.Daily
                  )
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    label: _ctx.$t('timeZone')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: $setup.form.timerConditions.executionTimeZone,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.form.timerConditions.executionTimeZone) = $event)),
                                        filterable: "",
                                        size: "small",
                                        onChange: $setup.emitUpdate
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.timeZoneOptions, (tz) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: tz.value,
                                              label: tz.label,
                                              value: tz.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "onChange"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (
                $setup.form.timerConditions.repeatFrequency === $setup.RepeatFrequency.Daily
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('runOnTheseDays')) + ":", 1),
                            _createVNode(_component_el_button, {
                              class: "ml-2",
                              type: "primary",
                              size: "small",
                              onClick: $setup.selectAllDays
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('selectAllDays')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      (
                $setup.form.timerConditions.repeatFrequency === $setup.RepeatFrequency.Daily
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.daysOfWeek, (day) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: day.value,
                                class: _normalizeClass([
                  'day-circle',
                  { active: $setup.selectedDays.includes(day.value) }
                ]),
                                onClick: ($event: any) => ($setup.toggleDay(day.value))
                              }, _toDisplayString(day.label), 11, _hoisted_8))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (
                $setup.form.timerConditions.repeatFrequency ===
                  $setup.RepeatFrequency.Daily && $setup.selectedDays.length
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_el_divider, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('requestBodySettings')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_tabs, {
                              modelValue: $setup.activeDay,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.activeDay) = $event)),
                              type: "card"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedDays, (dayValue) => {
                                  return (_openBlock(), _createBlock(_component_el_tab_pane, {
                                    key: dayValue,
                                    label: $setup.getDayLabel(dayValue),
                                    name: String(dayValue)
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_10, [
                                        ($setup.selectedDays.length > 1)
                                          ? (_openBlock(), _createBlock(_component_el_row, {
                                              key: 0,
                                              class: "mb-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_col, {
                                                  span: 24,
                                                  style: {"text-align":"right"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_dropdown, {
                                                      onCommand: 
                            targetDayValue =>
                              $setup.copyConfigToDay(dayValue, targetDayValue)
                          
                                                    }, {
                                                      dropdown: _withCtx(() => [
                                                        _createVNode(_component_el_dropdown_menu, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_el_dropdown_item, { command: "all" }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('allDays')), 1)
                                                              ]),
                                                              _: 1
                                                            }),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedDays.filter(
                                  d => d !== dayValue
                                ), (otherDay) => {
                                                              return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                                key: otherDay,
                                                                command: otherDay
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString($setup.getDayLabel(otherDay)), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["command"]))
                                                            }), 128))
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_el_button, {
                                                          type: "primary",
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('copyConfigTo')) + " ", 1),
                                                            _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_ArrowDown)
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onCommand"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_api_request_body_settings, {
                                          settings: $setup.daysRequestBodyTemplates[dayValue],
                                          onAddFilter: ($event: any) => (
                        $setup.addFilter($setup.daysRequestBodyTemplates[dayValue])
                      ),
                                          onDeleteFilter: 
                        filterIndex =>
                          $setup.deleteFilter(
                            $setup.daysRequestBodyTemplates[dayValue],
                            filterIndex
                          )
                      ,
                                          onChange: $setup.emitUpdate,
                                          onUpdateField: 
                        (field, value) =>
                          $setup.updateApiRequestBodyField(
                            $setup.daysRequestBodyTemplates[dayValue],
                            field,
                            value
                          )
                      
                                        }, null, 8, ["settings", "onAddFilter", "onDeleteFilter", "onChange", "onUpdateField"])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "name"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (
                $setup.form.timerConditions.repeatFrequency !== $setup.RepeatFrequency.Daily
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_el_divider, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('requestBodySettings')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_api_request_body_settings, {
                              settings: $setup.singleRequestBodyTemplate,
                              onChange: $setup.emitUpdate,
                              onAddFilter: _cache[13] || (_cache[13] = ($event: any) => ($setup.addFilter($setup.singleRequestBodyTemplate))),
                              onDeleteFilter: _cache[14] || (_cache[14] = 
                  filterIndex =>
                    $setup.deleteFilter($setup.singleRequestBodyTemplate, filterIndex)
                ),
                              onUpdateField: _cache[15] || (_cache[15] = 
                  (field, value) =>
                    $setup.updateApiRequestBodyField(
                      $setup.singleRequestBodyTemplate,
                      field,
                      value
                    )
                )
                            }, null, 8, ["settings", "onChange"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "actions-col-wrapper d-flex"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  (!$props.disableDeleteAndSave)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: require(`@/assets/images/icons/new/delete.svg`),
                        height: "20",
                        width: "20",
                        class: "action-icon cursor-pointer",
                        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => ($setup.deleteApiFileConfiguration && $setup.deleteApiFileConfiguration(...args)))
                      }, null, 8, _hoisted_13))
                    : _createCommentVNode("", true),
                  (!$props.disableDeleteAndSave)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "primary",
                        size: "large",
                        onClick: $setup.saveItem
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('save')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_gain_configuration_versions_modal, {
      modelValue: $setup.showVersionModal,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.showVersionModal) = $event)),
      "configuration-versions": $setup.props.configurationHistory,
      onRestore: $setup.handleRestore,
      onClose: _cache[18] || (_cache[18] = ($event: any) => ($setup.showVersionModal = false))
    }, null, 8, ["modelValue", "configuration-versions", "onRestore"])
  ], 64))
}